import store from '@/store';
import { ACCOUNT_REPLACE_COMPLIANCE } from '@/store/modules/account/mutation-types';

export async function updateCompliance(vue, complianceType) {
  // ✅ Snapshot ANTES del update
  const before = store.state.account.accountCompliance;

  // Si ya estaba "full" antes de este step, es cuenta vieja backfilleada — no mostrar reward
  const wasAlreadyFull = !!(
    before?.practiceOrderCompletedAt &&
    before?.businessConfiguredAt &&
    before?.firstRealOrderCompletedAt &&
    before?.firstProductAddedAt &&
    before?.reportsVisitedAt
  );

  await store.dispatch(ACCOUNT_REPLACE_COMPLIANCE, {
    ...before,
    [complianceType]: before?.[complianceType] ?? new Date().toISOString(),
  });

  const c = store.state.account.accountCompliance;
  const isFull = !!(
    c?.practiceOrderCompletedAt &&
    c?.businessConfiguredAt &&
    c?.firstRealOrderCompletedAt &&
    c?.firstProductAddedAt &&
    c?.reportsVisitedAt
  );

  if (isFull && !wasAlreadyFull) { // ✅ Solo emite si el usuario realmente progresó
    vue.$root.$emit('compliance:completed');
  }
}